import { runtimeEnv } from 'config/runtimeEnv';
import requestInstance from './Request';

// Borrow-a-seat endpoints live on the auth service — same base as the login
// endpoints in services/Api.js (/auth/v1/*).
const BASE_URL = `${runtimeEnv('B2B_API_BASE_URL')}/auth/v1`;

// GET /auth/v1/assume-options — super-admin (role 99) only; the backend
// enforces this (403 otherwise). Returns {success, data:{tenants, roles}}.
export const assumeOptionsApi = async () => {
  const response = await requestInstance.get(`${BASE_URL}/assume-options`);
  return response.data;
};

// POST /auth/v1/assume-tenant {tenantId, role} — returns an ordinary tenant
// token (claims tenantId=<target>, role=<chosen>, assumed:true, assumedBy).
// Content-Type must be explicit: the request interceptor defaults POSTs
// without one to x-www-form-urlencoded, and this endpoint expects JSON.
export const assumeTenantApi = async ({ tenantId, role }) => {
  const response = await requestInstance.post(
    `${BASE_URL}/assume-tenant`,
    { tenantId, role },
    { headers: { 'Content-Type': 'application/json' } }
  );
  return response.data;
};
